import type { EffectivePen } from './effectiveRows';
import type { FormDiff } from './formDiff';

/**
 * The keys of a pen's stored values the field cannot read, which a client admin is not
 * shown, and which this save leaves as stored. The value exists, so every requirement rule
 * counts it as set, as the server's does (provider-config-validation.ts `held`). A blocked
 * key is left out: no save can write it, and it is not required.
 */
export function heldKeys(diff: FormDiff, pen: EffectivePen): ReadonlySet<string> {
    const written = new Set([
        ...Object.keys(diff.connection),
        ...Object.keys(pen.diff?.fields ?? {}),
    ]);
    const keys = (pen.row?.unreadable ?? [])
        .filter((entry) => !entry.blocked)
        .map((entry) => entry.key.split('[')[0]);
    return new Set(keys.filter((key) => !written.has(key)));
}
